import type { BugListItem } from '../../data/projectTypes'
import EnvironmentBadge from '../EnvironmentBadge'
import PullRequestCheckStatus from '../PullRequestCheckStatus'
import '../EnvironmentBadge.css'

export default function BugEnvironment({ bug }: { bug: BugListItem }) {
  const fixes = bug.fix_prs?.filter(pr => pr.active !== false)
  const prs = fixes?.length
    ? fixes.map(pr => ({ ...pr, label: 'Fix PR' }))
    : bug.pr_number && bug.pr_repo_full_name
      ? [{ repo_full_name: bug.pr_repo_full_name, pr_number: bug.pr_number, label: 'Introduction PR' }]
      : []
  if (!prs.length) return <EnvironmentBadge artifact={bug} />
  return <span className="bug-environment-prs">{prs.map(pr => (
    <a
      key={`${pr.repo_full_name}#${pr.pr_number}`}
      href={`https://github.com/${pr.repo_full_name}/pull/${pr.pr_number}`}
      className="environment-badge environment-badge--preview"
      target="_blank" rel="noopener noreferrer" data-no-navigate
      onClick={event => event.stopPropagation()}
      data-analytics-event={pr.label === 'Fix PR' ? 'bug-fix-pr-link' : 'bug-pr-link'}
    >
      {pr.label} # {pr.pr_number}
      <PullRequestCheckStatus projectId={bug.project_id} repo={pr.repo_full_name} pr={pr.pr_number} />
    </a>
  ))}</span>
}
